import { Component, Inject, Injector } from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ViewComponent } from 'src/app/pages/abstract/view.component';
import { ApiKeyForCreate, ApiKeyService } from 'src/app/services/apikey-service';


@Component({
    selector: 'apikey-regist-dialog',
    templateUrl: 'apikey-regist-dialog.html',
    styleUrls: ['apikey-regist-dialog.scss'],
})
export class ApiKeyRegistDialog extends ViewComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public params: { [key: string]: any },
        protected override injector: Injector,
        public dialogRef: MatDialogRef<ApiKeyRegistDialog>,
        private router: Router,
        private apiKeyService: ApiKeyService,
        public dialog: MatDialog,
        private translate: TranslateService,
        private fb: FormBuilder,
    ) {
        super(injector);
    }


    isButtonDisabled: boolean = false;

    data = new ApiKeyForCreate();

    ngOnInit() {
        this.createFormGroup(this.data).then(() => {
            const restrictionCtrl = this.form.get('restriction');
            restrictionCtrl?.valueChanges.subscribe(val => {
                if ((val === 'HTTP' || val === 'IP') && this.restrictions.length === 0) {
                    this.addRestrictionText();
                }
            });
            const val = restrictionCtrl?.value;
            if ((val === 'HTTP' || val === 'IP') && this.restrictions.length === 0) {
                this.addRestrictionText();
            }
        });
    }

    onClickRegist(): void {
        this.form.markAllAsTouched();
        this.form.updateValueAndValidity();

        if (this.form.invalid) {
            this.handlError(this.translate.instant('MESSAGES.FORM_INVALID'));
            this.scrollToMessages();
        } else {
            this.disableAllFormControl();
            this.isButtonDisabled = true;
            const data = this.updateDataWithForm<ApiKeyForCreate>(new ApiKeyForCreate(), this.form);
            this.apiKeyService.create(data)
                .subscribe({
                    next: (result) => {
                        this.enableAllFormControl();
                        this.isButtonDisabled = false;
                        this.dialogRef.close(result)
                    },
                    error: (error) => {
                        this.enableAllFormControl();
                        this.handlError(error, this.form);
                        console.error('Error response:', error, this.form);
                        this.isButtonDisabled = false;
                    }
                });
        }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }


    get restrictions(): FormArray {
        return this.form.get('restrictions') as FormArray;
    }

    addRestrictionText(): void {
        this.restrictions.push(this.fb.control('', Validators.required));
    }

    removeRestrictionText(index: number): void {
        this.restrictions.removeAt(index);
    }

    isRestricted(): boolean {
        const val = this.form.get('restriction')?.value;
        return val === 'HTTP' || val === 'IP';
    }

    // string[] に変換する時（送信時など）
    get restrictionValues(): string[] {
        return this.restrictions.controls.map(control => control.value);
    }

}
